import { Trans } from "@lingui/macro";
import { Stethoscope } from "lucide-react";

/**
 * Says why a patient list is shorter than the reader's pool: it follows the practitioner the
 * dashboard is narrowed to (PT-111). Without it, the picker on a patient page would simply look
 * incomplete — the chip that names the narrowing lives on the dashboard.
 */
export function PractitionerFilterHint({ label }: { label: string }) {
  return (
    <div className="flex items-center gap-1.5 border-b border-slate-100 px-3 py-1.5 text-2xs text-slate-500">
      <Stethoscope className="h-3 w-3 shrink-0 text-primary" />
      <span className="truncate">
        <Trans>
          Praticien : <span className="font-medium text-primary">{label}</span>
        </Trans>
      </span>
    </div>
  );
}
